export class VerisoulHelper {
    verisoulScript: HTMLScriptElement;
    initializeSession: boolean;
    myAccountLogout: HTMLAnchorElement;
    navbarLogout: HTMLAnchorElement;
    reinitializeSessionButton: HTMLButtonElement;
    redirectButtonDiv: HTMLDivElement;
    errorMessage: HTMLDivElement;
    pageReinitialize: any;

    constructor() {
        this.init();
    }

    init() {
        this.verisoulScript = document.querySelector('[data-verisoul-initialize-session]');
        this.initializeSession = this.verisoulScript ? this.verisoulScript.getAttribute("data-verisoul-initialize-session") === "True" : false;
        this.myAccountLogout = document.querySelector('[data-account-reinitialize-session]');
        this.navbarLogout = document.querySelector('[data-navbar-reinitialize-session]');
        this.reinitializeSessionButton = document.querySelector('[data-verisoul-reinitialize]');
        this.redirectButtonDiv = document.querySelector('[data-verisoul-success]');
        this.errorMessage = document.querySelector('[data-verisoul-error]');
        this.pageReinitialize = document.querySelector('[data-verisoul-reinitialize-page]');

        if (this.initializeSession) {
            this.initializeVerisoulSession(false);
        }

        if (this.myAccountLogout) {
            this.myAccountLogout.addEventListener('click', () => {
                this.reinitializeVerisoulSession(false);
            });
        }

        if (this.navbarLogout) {
            this.navbarLogout.addEventListener('click', () => {
                this.reinitializeVerisoulSession(false);
            });
        }

        if (this.reinitializeSessionButton) {
            this.reinitializeSessionButton.addEventListener('click', () => {
                this.reinitializeVerisoulSession(true);
            });
        }

        if (this.pageReinitialize) {
            this.reinitializeVerisoulSession(false);
        }
    }

    initializeVerisoulSession(checkSessionInformation: boolean) {
        if ((window as any).Verisoul) {
            (window as any).Verisoul.session().then(response => {
                if (response == "" || response == undefined) {
                    this.initializeVerisoulSession(checkSessionInformation);
                } else {
                    this.updateVerisoulSessionIdAndAuthenticateSession(response.session_id, checkSessionInformation);
                }
            });
        }
        else {
            setTimeout(() => {
                this.initializeVerisoulSession(checkSessionInformation);
            }, 100)
        }
    }

    reinitializeVerisoulSession(checkSessionInformation: boolean) {
        if ((window as any).Verisoul) {
            (window as any).Verisoul.reinitialize().then(response => {
                this.initializeVerisoulSession(checkSessionInformation);
            });
        }
        else {
            setTimeout(() => {
                this.reinitializeVerisoulSession(checkSessionInformation);
            }, 100)
        }
    }

    updateVerisoulSessionIdAndAuthenticateSession(sessionId, checkSessionInformation) {
        fetch(`/api/verisoul/UpdateVerisoulSessionIdAndAuthenticateSession?sessionId=${sessionId}&checkSessionInformation=${checkSessionInformation}`,
            {
                method: 'Post', headers: {
                    "Content-type": "application/json; charset=UTF-8"
                }
            }
        ).then(response => {
            return response.json();
        }).then(data => {
            if (checkSessionInformation) {
                if (data) {
                    if (this.redirectButtonDiv) {
                        this.redirectButtonDiv.classList.remove('hide');
                    }
                    if (this.errorMessage) {
                        this.errorMessage.classList.add('hide');
                    }
                }
                else {
                    if (this.redirectButtonDiv) {
                        this.redirectButtonDiv.classList.add('hide');
                    }
                    if (this.errorMessage) {
                        this.errorMessage.classList.remove('hide');
                    }
                }
            }
        });
    }
}